import { render, staticRenderFns } from "./HRAdmin.vue?vue&type=template&id=60934c46&scoped=true"
import script from "./HRAdmin.vue?vue&type=script&lang=js"
export * from "./HRAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60934c46",
  null
  
)

export default component.exports